import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { root } from '../../../../../../../../../store/constants';

export const onClose = (): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        root.App.controller.allowCounterSnackbarHelper.setSnackbarShown('allowStatusMapping');
    };
    return action;
};
